import Garage from "./Garage";

export default Garage; 